import { Pipe, PipeTransform } from "@angular/core";
import { stringTruncateMiddle } from "src/app/support/string";

@Pipe({
  name: "truncateMiddle",
  standalone: false
})
export class TruncateMiddlePipe implements PipeTransform {
  transform(value: string, leftChars: number, rightChars: number): string {
    return stringTruncateMiddle(value, leftChars, rightChars);
  }
}
